import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { T } from "react-translator-component";
import { useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Button } from "@mui/material";
import LoadingModal from "../../../../components/LoadingModal";
import { setErrorObj } from "../../../redux/errorReducer";
import { useAppDispatch } from "../../../../redux/store";
import { setProps } from "../../../redux/createOpinionReducer";
import apiServices from "../../../services/apiServices";
import { isPostCreator } from "../../../../util/utils";

interface Props {
  post: any;
}

export default function OpinionsHeader({ post }: Props) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { admin } = useSelector((state: any) => state.adminAuth);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleCreateOpinion = async () => {
    try {
      setIsLoading(true)
      const res = await apiServices.getPost(post.id)
      dispatch(setProps(res.post))
      navigate("/mng/create_opinion_post")
    } catch (error: any) {
      dispatch(setErrorObj(error))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <LoadingModal visible={isLoading} />
      <Box sx={styles.container}>
        {isPostCreator(post, admin) && (
          <Button
            style={styles.button}
            onClick={() => { handleCreateOpinion() }}
            color={"secondary"}
            variant="text"
            startIcon={<EditIcon style={styles.icon} fontSize="small" />}
          >
            {T("edit_post")}
          </Button>
        )}
      </Box>
    </>
  );
}

const styles = {
  container: {
    display: "flex"
  },
  button: { fontSize: 10 },
  icon: { marginRight: 0 }
};
